var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 7.99998V2.66665C30.6667 2.31302 30.5262 1.97388 30.2762 1.72384C30.0261 1.47379 29.687 1.33331 29.3333 1.33331H2.66668C2.31305 1.33331 1.97392 1.47379 1.72387 1.72384C1.47382 1.97388 1.33334 2.31302 1.33334 2.66665V7.99998H30.6667Z",
    fill: "#2EC5CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 10.6666V29.3333C1.33334 29.6869 1.47382 30.0261 1.72387 30.2761C1.97392 30.5262 2.31305 30.6666 2.66668 30.6666H9.33334V10.6666H1.33334Z",
    fill: "#D6B1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30.6666H29.3333C29.687 30.6666 30.0261 30.5262 30.2761 30.2761C30.5262 30.0261 30.6667 29.6869 30.6667 29.3333V10.6666H12V30.6666Z",
    fill: "#8C30F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.fe9e52836b43f89071b20012530364b1.svg";
export { ForwardRef as ReactComponent };